module.exports = __webpack_public_path__ + "img/pro-photo6.40eece43.png";